import { render, staticRenderFns } from "./DaemonTestDeploy.vue?vue&type=template&id=bef7bd80&scoped=true"
import script from "./DaemonTestDeploy.vue?vue&type=script&lang=js"
export * from "./DaemonTestDeploy.vue?vue&type=script&lang=js"
import style0 from "./DaemonTestDeploy.vue?vue&type=style&index=0&id=bef7bd80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef7bd80",
  null
  
)

export default component.exports